import { reactive } from "vue";

export const themeStore = reactive({
  isDarkMode: window.matchMedia("(prefers-color-scheme: dark)").matches,

  setTheme(isDark: boolean) {
    this.isDarkMode = isDark;
    document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
    localStorage.setItem("theme", isDark ? "dark" : "light");
  },

  toggleTheme() {
    this.setTheme(!this.isDarkMode);
  },

  loadTheme() {
    const saved = localStorage.getItem("theme");
    if (saved === "light" || saved === "dark") {
      this.setTheme(saved === "dark");
    } else {
      this.setTheme(window.matchMedia("(prefers-color-scheme: dark)").matches);
    }

    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
      if (!localStorage.getItem("theme")) {
        this.setTheme(e.matches);
      }
    });
  }
});

themeStore.loadTheme();